var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.user)?_c('TheLockPage'):_vm._e(),(_vm.user)?_c('TheApplication'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }